export default class LifeConfigurationCapitalOption {
  age: number
  older: boolean
  equals: boolean
  min: number
  max: number

  constructor(data: LifeConfigurationCapitalOption) {
    this.age = data.age
    this.older = data.older
    this.equals = data.equals
    this.min = data.min
    this.max = data.max
  }
}
